<nz-upload
  [nzDisabled]="isDisabled()"
  [nzType]="uploadVisibility()"
  [nzShowButton]="false"
  [nzLimit]="sizeLimit()"
  [nzAccept]="fileTypes()"
  [nzMultiple]="allowMultiple()"
  [nzFileList]="fileList()"
  [nzFileListRender]="fileListTpl"
  [nzCustomRequest]="uploadRequest"
  (nzChange)="onHandleChange($event)"
>
  <div class="ant-upload-drag-container">
    <nz-icon nzType="upload" />

    <h5>
      {{ 'shared.upload.dragTitle' | translate }}

      <small>
        @let size = sizeLimit() | formatFileSize;
        @let types = allowedFileTypes();

        {{ 'shared.upload.dragSubtitle' | translate: { size, types } }}
      </small>
    </h5>

    <button
      nz-button
      nzType="default"
      nzSize="small"
      class="ant-btn-secondary"
      [disabled]="isDisabled()"
    >
      {{ 'shared.upload.browseFiles' | translate }}
    </button>
  </div>
</nz-upload>

<ng-template #fileListTpl>
  <moxi-upload-list
    [isDisabled]="isDisabled()"
    [fileList]="fileList()"
    (removeFile)="onRemoveFile($event)"
    (downloadFile)="onDownloadFile($event)"
  />
</ng-template>
